<template>
  <el-button icon="Search" style="float: right; margin: 5px;" @click="searchUser()" circle />

<input
  class="input-field"
  type="search"
  placeholder="用户名"
  id="keyword"
  style="float: right;"
/>


<table class="table caption-top">
  <caption>
    详细列表:
  </caption>

  <thead>
    <tr>
      <th scope="col">用户头像</th>
      <th scope="col">用户名</th>
      <th scope="col">用户昵称</th>
      <th scope="col">提交时间</th>
      <th scope="col">得分</th>
      <th scope="col">是否及格</th>
      <th scope="col">操作</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="record in records" :key="record.recordId">
      <td><img :src="record.user.avatar" style="width: 50px; height: 50px"/> </td>
      <td>{{ record.user.userName }}</td>
      <td>{{ record.user.nickName }}</td>
      <td>{{ record.createTime }}</td>
      <td>{{ record.score }}</td>
      <td>
        <el-button type="warning" class="courseBtn" v-if=" record.score == null" plain>未批改</el-button>
        <el-button type="danger" class="courseBtn" v-if="record.score != null && record.isPass == 0" plain>未及格</el-button>
        <el-button type="success" class="courseBtn" v-if="record.score != null&& record.isPass == 1" plain>及格</el-button>
    </td>
      <td>
        <el-button
          type="warning"
          @click="ManualCorrectExam(record.recordId);"
          class="courseBtn"
          plain
        >
          手动批改
        </el-button>

        <el-button
          type="success"
          @click="autoCorrectHomework(record.recordId);"
          class="courseBtn"
          plain
        >
          一键批改
        </el-button>

        <el-popconfirm
            title="确定打回学生作业吗？"
            @confirm="repulseExam(record.recordId)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
                <el-button type="danger" v-if=" record.score != null" class="courseBtn" plain>打回</el-button>
            </template>
          </el-popconfirm>
      </td>
    </tr>
  </tbody>
</table>

<nav aria-label="...">
  <ul class="pagination" style="float: center">
    <li class="page-item" @click="click_page(-2)">
      <a class="page-link" href="#">前一页</a>
    </li>
    <li
      :class="'page-item ' + page.is_active"
      v-for="page in pages"
      :key="page.number"
      @click="click_page(page.number)"
    >
      <a class="page-link" href="#">{{ page.number }}</a>
    </li>
    <li class="page-item" @click="click_page(-1)">
      <a class="page-link" href="#">后一页</a>
    </li>
  </ul>
</nav>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import $ from "jquery";
import { useRoute } from "vue-router";
import router from "@/router/index";


let current_page = 1;
let keyword = ref('');
let courseId = ref('');
let examId = ref('');
let total_records = 0;
let pages = ref([]);
let records = ref([]);
const Route = useRoute(); //获取到值

// 在组件初始化时获取路由参数并设置为 current_page
onMounted(() => {
  // 获取路由参数并设置为 current_page
  current_page = parseInt(Route.params.page) || 0;

  keyword.value = Route.params.keyword || '';
  courseId.value = Route.params.courseId || '';
  examId.value = Route.params.examId || '';

  pullRecords(current_page, keyword.value);
});


// 加载记录信息
const pullRecords = (page, keyword) => {
  current_page = page;

  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/homework/getHomeworkRecord",
    data: {
      examId: examId.value,
      page: page,
      userName: keyword
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
        records.value = resp.data.list;
        total_records = resp.data.total;
        udpate_pages();
    },
    error() {
      ElMessage({
        type: "error",
        message: "拉取作业信息失败!"
      });
    },
  });
};

const click_page = (page) => {
  if (page === -2) page = current_page - 1;
  else if (page === -1) page = current_page + 1;
  let max_pages = parseInt(Math.ceil(total_records / 10));

  if (page >= 1 && page <= max_pages) {
    let keyword = $("#keyword").val();
    pullRecords(page, keyword);
  }
};

const udpate_pages = () => {
  let max_pages = parseInt(Math.ceil(total_records / 10));
  let new_pages = [];
  for (let i = current_page - 2; i <= current_page + 2; i++) {
    if (i >= 1 && i <= max_pages) {
      new_pages.push({
        number: i,
        is_active: i === current_page ? "active" : "",
      });
    }
  }
  pages.value = new_pages;
  let keyword = $("#keyword").val();
  console.log(examId.value + "-" + courseId.value +"-" + keyword.value + "-");
  router.push({name: 'CorrectHomework', params: {examId: examId.value, courseId: courseId.value, page: current_page, keyword: keyword.value} });
};

const searchUser = () => {
  let keyword = $("#keyword").val();
  pullRecords(1, keyword);
}

const autoCorrectHomework = (id) => {
    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/homework/autoCorrectExam",
        data: {
            recordId: id,
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
            ElMessage({
                type: resp.code =="200" ? "success" : "error",
                message: resp.msg
            });
            setTimeout(() => {
                pullRecords(current_page, keyword.value);    
            }, 200);
            
        },
        error() {
        ElMessage({
            type: "error",
            message: "拉取作业信息失败!"
        });
        },
    });
}


const ManualCorrectExam = (id) => {
    router.push({name: 'ManualCorrectExam', params: {recordId: id, courseId: courseId.value} });
}

const repulseExam = (id) => {
    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/homework/repulseExam",
        data: {
            recordId: id,
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
            ElMessage({
                type: resp.code =="200" ? "success" : "error",
                message: resp.msg
            });
            setTimeout(() => {
                pullRecords(current_page, keyword.value);    
            }, 200);
            
        },
        error() {
        ElMessage({
            type: "error",
            message: "打回失败!"
        });
        },
    });
}
</script>

<style scoped>
.input-field {
    width: 300px; /* 输入框宽度 */
    padding: 5px;
    border: 1px solid #ccc; /* 边框样式 */
    border-radius: 5px; /* 边框圆角 */
    font-size: 16px; /* 字体大小 */
    outline: none; /* 去除默认轮廓 */
}
.input-field:hover,
.input-field:focus {
    border-color: #66afe9; /* 修改边框颜色 */
    box-shadow: 0 0 5px rgba(102, 175, 233, 0.6); /* 添加阴影效果 */
}
</style>